module.exports = __webpack_public_path__ + "font.39fc3d391b79fa86e3ed.ttf";


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/assets/font/font.ttf
// module id = ../../../../../src/assets/font/font.ttf
// module chunks = 1 2